export const BaseTemplates = {
  '{newline}': <br />,
  '{sp}': <>&nbsp;</>,
};
